module.exports = __webpack_public_path__ + "img/environmentIMG.e1bd83bc.png";